// Keeps the layout store's uid in step with the Better Auth session. The
// session resolves asynchronously after boot (one fetch, see
// auth/useSession.ts), so the one-shot stored-layout apply happens here.

import { useEffect } from 'react';
import { useSession } from '../../auth/useSession.js';
import { usePanelLayout } from './usePanelLayout.js';

/**
 * Mount once (App calls it unconditionally, above the game-mode branches):
 * signs the store in when the session resolves, back out to guest on
 * sign-out. Auth unconfigured / network down degrades to guest — the same
 * additive contract as the rest of the auth seam.
 */
export function usePanelLayoutSession(): void {
  const { state } = useSession();
  const setUser = usePanelLayout((s) => s.setUser);
  useEffect(() => {
    if (state.status === 'signed-in') setUser(state.user.id);
    else if (state.status === 'signed-out') setUser(null);
  }, [state, setUser]);
}
